// Traducciones al inglés: clave = texto en español exactamente como en el código.
// Donaciones: resumen, lotes, donaciones, fondos, campañas, recurrentes y constancias.
export default {
  // Etiquetas
  'Efectivo': 'Cash',
  'Cheque': 'Check',
  'Tarjeta': 'Card',
  'Transferencia': 'ACH',
  'Otro': 'Other',
  'Pendiente': 'Pending',
  'Recibida': 'Received',
  'Fallida': 'Failed',
  'Reembolsada': 'Refunded',
  'Reembolso parcial': 'Partially refunded',
  'Semanal': 'Weekly',
  'Cada dos semanas': 'Every two weeks',
  'Mensual': 'Monthly',

  // Navegación
  'Resumen': 'Summary',
  'Lotes': 'Batches',
  'Fondos': 'Funds',
  'Campañas': 'Campaigns',
  'Recurrentes': 'Recurring',
  'Constancias': 'Statements',

  // Resumen
  'Totales netos (descontando reembolsos) por fondo, campus y mes.': 'Net totals (after refunds) by fund, campus and month.',
  'Desde': 'From',
  'Hasta': 'To',
  'Total neto': 'Net total',
  'Donantes': 'Donors',
  'Promedio': 'Average',
  'Por mes': 'By month',
  'Por fondo': 'By fund',
  'Por campus': 'By campus',
  'Por método': 'By method',
  'Sin datos': 'No data',
  'Sin campus': 'No campus',

  // Lotes
  'Registra las ofrendas de cada servicio en un lote y confírmalo al cuadrar.': 'Record each service’s offering in a batch and commit it once it balances.',
  'Ofrendas {date}': 'Offering {date}',
  '+ Nuevo lote': '+ New batch',
  'Nuevo lote': 'New batch',
  'Estado': 'Status',
  'En proceso': 'In progress',
  'Confirmados@@lote': 'Committed',
  'Confirmado@@lote': 'Committed',
  'Confirmado {date}': 'Committed {date}',
  'Sin lotes': 'No batches',
  'Descripción': 'Description',
  'Total': 'Total',
  '¿Eliminar este lote vacío?': 'Delete this empty batch?',
  'Se confirmará el lote con {n} donación por {total}. Después ya no se podrá modificar.': 'This will commit the batch with {n} donation totaling {total}. It can’t be changed afterward.',
  'Se confirmará el lote con {n} donaciones por {total}. Después ya no se podrá modificar.': 'This will commit the batch with {n} donations totaling {total}. It can’t be changed afterward.',
  'Lote confirmado': 'Batch committed',
  'Confirmar lote': 'Commit batch',
  'Total del lote': 'Batch total',
  '{n} donación': '{n} donation',
  '{n} donaciones': '{n} donations',
  'Total contado (para cuadrar)': 'Counted total (to reconcile)',
  '✓ Cuadra': '✓ Balanced',
  'Diferencia: {amount}': 'Difference: {amount}',
  'Registrar donación': 'Record donation',
  'Donaciones del lote': 'Donations in this batch',
  'Aún no hay donaciones': 'No donations yet',
  'Donante': 'Donor',
  'Anónimo': 'Anonymous',
  'Método': 'Method',
  'Monto': 'Amount',
  '¿Eliminar esta donación?': 'Delete this donation?',
  'Editar donación': 'Edit donation',

  // Formulario de donación
  'Revisa los montos: usa números como 25 o 25.50': 'Check the amounts: use numbers like 25 or 25.50',
  'Elige un fondo': 'Choose a fund',
  'Donación de {amount} registrada': '{amount} donation recorded',
  'Donante (vacío = anónimo)': 'Donor (leave empty for anonymous)',
  'Número de cheque': 'Check number',
  'Fecha': 'Date',
  'Fondo': 'Fund',
  '+ Dividir en otro fondo': '+ Split to another fund',
  'Nota (opcional)': 'Note (optional)',
  'Guardar cambios': 'Save changes',
  'Guardar (Enter)': 'Save (Enter)',

  // Donaciones
  '{n} donación · {net} netos': '{n} donation · {net} net',
  '{n} donaciones · {net} netos': '{n} donations · {net} net',
  'Sin donaciones con estos filtros': 'No donations match these filters',
  'En línea': 'Online',
  'en línea': 'online',
  'Donación': 'Donation',
  'Ver donante': 'View donor',
  'Comisión del procesador: {amount}': 'Processing fee: {amount}',
  'Reembolsos': 'Refunds',
  'Registrar reembolso (disponible {amount})': 'Record refund ({amount} available)',
  'Monto del reembolso': 'Refund amount',
  'Motivo': 'Reason',
  'Se devolverá el dinero a la tarjeta del donante a través de Stripe.': 'The money will be returned to the donor’s card through Stripe.',
  'Se registrará el reembolso (devuelve el dinero por tu cuenta).': 'The refund will be recorded (return the money yourself).',
  'Monto inválido': 'Invalid amount',
  'Reembolsar': 'Refund',

  // Fondos
  '+ Nuevo fondo': '+ New fund',
  'Predeterminado': 'Default',
  'Inactivo': 'Inactive',
  'Solo personal': 'Staff only',
  'Deducible': 'Tax-deductible',
  'No deducible': 'Not tax-deductible',
  'Sin fondos': 'No funds',
  'Editar fondo': 'Edit fund',
  'Nuevo fondo': 'New fund',
  'Nombre@@objeto': 'Name',
  'Código contable': 'Accounting code',
  'Visible para': 'Visible to',
  'Todos (incluye donaciones en línea)': 'Everyone (includes online giving)',
  'Fondo predeterminado': 'Default fund',
  'Deducible de impuestos (aparece en constancias)': 'Tax-deductible (appears on giving statements)',
  'Activo': 'Active',

  // Campañas
  'Compromisos de donación (p. ej. construcción) y su avance.': 'Giving pledges (e.g., building campaigns) and their progress.',
  '+ Nueva campaña': '+ New campaign',
  '+ Compromiso': '+ Pledge',
  'Recibido': 'Received',
  'Comprometido': 'Pledged',
  '{n} persona': '{n} person',
  '{n} personas': '{n} people',
  'Meta': 'Goal',
  'Periodo': 'Period',
  '{pct}% de la meta': '{pct}% of goal',
  '{pct}% de lo comprometido': '{pct}% of pledged',
  'Sin campañas': 'No campaigns',
  'Nueva campaña': 'New campaign',
  'Meta inválida': 'Invalid goal',
  'Elige…': 'Choose…',
  'Inicio@@fecha': 'Start',
  'Fin': 'End',
  'Meta (opcional)': 'Goal (optional)',
  'Toda la organización': 'Entire organization',
  'Registrar compromiso': 'Record pledge',
  'Compromiso registrado': 'Pledge recorded',
  'Monto total comprometido': 'Total pledge amount',
  'Si la persona ya tenía un compromiso, se reemplaza.': 'If this person already has a pledge, it will be replaced.',

  // Recurrentes
  'Donaciones recurrentes': 'Recurring donations',
  '+ Nueva': '+ New',
  'Sin donaciones recurrentes': 'No recurring donations',
  'Frecuencia': 'Frequency',
  'Próximo': 'Next',
  'Activa': 'Active',
  'Pausada': 'Paused',
  'Cancelada': 'Canceled',
  'Pausar': 'Pause',
  'Reanudar': 'Resume',
  '¿Cancelar esta donación recurrente?': 'Cancel this recurring donation?',
  'Nueva donación recurrente': 'New recurring donation',
  'Próximo pago': 'Next payment',

  // Constancias
  'Constancias: {generated} generadas, {sent} enviadas por correo': 'Statements: {generated} generated, {sent} emailed',
  '{n} constancia generada': '{n} statement generated',
  '{n} constancias generadas': '{n} statements generated',
  'Constancias anuales': 'Giving statements',
  'Total deducible por donante (descuenta reembolsos; solo fondos deducibles).': 'Tax-deductible total per donor (net of refunds; tax-deductible funds only).',
  'Generar': 'Generate',
  'Se enviará por correo la constancia {year} a cada donante con correo registrado.': 'The {year} giving statement will be emailed to every donor with an email address on file.',
  'Generar y enviar': 'Generate and send',
  'Año': 'Year',
  '{n} donante · {total} deducibles en {year}.': '{n} donor · {total} tax-deductible in {year}.',
  '{n} donantes · {total} deducibles en {year}.': '{n} donors · {total} tax-deductible in {year}.',
  'Sin donaciones deducibles en {year}': 'No tax-deductible donations in {year}',
  'Enviada': 'Sent',
  'PDF ↗': 'PDF ↗',
  "Depósitos de Stripe": "Stripe payouts",
  "Las «en línea» las cobra la plataforma con Stripe en cada fecha; las «registradas» son compromisos que la iglesia anota (transferencia automática, etc.).": "“Online” gifts are charged by the platform through Stripe on each date; “recorded” ones are commitments the church notes down (automatic bank transfers, etc.).",
  "Cómo": "How",
  "Registrada": "Recorded",
  "{n} cobro fallido": "{n} failed charge",
  "{n} cobros fallidos": "{n} failed charges",
  "Stripe revisado: {events} eventos nuevos, {charged} cobros recurrentes.": "Stripe checked: {events} new events, {charged} recurring charges.",
  "Cada depósito de Stripe a la cuenta de la iglesia se concilia solo: se crea un lote con sus donaciones y la comisión real de cada una. Lo que no corresponde a una donación se muestra para revisarlo.": "Each Stripe payout to the church’s account reconciles itself: a batch is created with its gifts and each one’s actual fee. Anything that doesn’t match a gift is shown for review.",
  "Revisar Stripe ahora": "Check Stripe now",
  "Sin depósitos todavía": "No payouts yet",
  "Aparecen aquí cuando Stripe deposita las donaciones en línea en la cuenta de la iglesia.": "They show up here when Stripe deposits online gifts into the church’s account.",
  "Llega": "Arrives",
  "Comisiones": "Fees",
  "Depositado": "Deposited",
  "Por revisar": "To review",
  "{n} otro movimiento": "{n} other transaction",
  "{n} otros movimientos": "{n} other transactions",
  "{n} cobro sin donación": "{n} charge without a gift",
  "{n} cobros sin donación": "{n} charges without a gift",
  "Cuadra": "Balanced",
  "Ver lote": "View batch",
} satisfies Record<string, string>;
